import { createContent } from '@altify/utils';

export const exploreVerificationContent = createContent({
  en: {
    completed: 'Completed',
    verifyIdentity: {
      heading: 'Verify Your Identity',
      subHeading: 'As a regulated platform, we verify your identity and personal details to protect you from fraud.',
      steps: [
        { 
          id: 'create',
          heading: 'Create Account',
          subHeading: 'Completed',
        },
        {
          id: 'verify',
          heading: 'Verify Account',
          subHeading: 'Verify Your Identity',
          continueHeading: 'Complete Verification'
        },
      ],
    },
    underReview: {
      heading: 'Verification Under Review',
      subHeading: 'We\'re reviewing your details and will email you within 24 - 48 hours.\n\nIn the meantime, why not explore our investment options.',
    },
    verificationCompleted: {
      heading: 'Verification Complete',
      subHeading: 'Next, fund your account with a zero fee bank or crypto deposit.',
    },
    informationRequest: {
      heading: 'Information Request',
      subHeading: 'We require additional information in order to verify your account. ',
    },
    securedData: 'Your data is stored securely',
    continue: 'Continue',
    exploreInvestments: 'Explore Investments',
    bankDeposit: 'Bank Deposit',
    cryptoDeposit: 'Crypto Deposit',
    shareNow: 'Share Now',
    later: 'Later',
  },
  de: {
    completed: 'Completed',
    verifyIdentity: {
      heading: 'Verify Your Identity',
      subHeading: 'As a regulated platform, we verify your identity and personal details to protect you from fraud.',
      steps: [
        { 
          id: 'create',
          heading: 'Create Account',
          subHeading: 'Completed',
        },
        {
          id: 'verify',
          heading: 'Verify Account',
          subHeading: 'Verify Your Identity',
          continueHeading: 'Complete Verification'
        },
      ],
    },
    underReview: {
      heading: 'Verification Under Review',
      subHeading: 'We’ll email you when your account is verified.\n\nExplore our products while you wait.',
    },
    verificationCompleted: {
      heading: 'Verification Complete',
      subHeading: 'Next, fund your account with a zero fee bank or crypto deposit.',
    },
    informationRequest: {
      heading: 'Information Request',
      subHeading: 'We require additional information in order to verify your account. ',
    },
    securedData: 'Your data is stored securely',
    continue: 'Continue',
    exploreInvestments: 'Explore Investments',
    bankDeposit: 'Bank Deposit',
    cryptoDeposit: 'Crypto Deposit',
    shareNow: 'Share Now',
    later: 'Later',
  },
});
